import {create} from 'zustand'
console.log("ahorita se ejecuta zustand");
export const useUser = create((set) => ({
  user: { name : '', tipo : '' , id_user : '' },
  setUser: (user) => set(state => ({ ...state, user }))
}))